import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/content';
import { images } from '../data/offer';
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * buyers.length));
  const [open, setOpen] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    const show = () => {
      setIndex(i => (i + 1 + Math.floor(Math.random() * 3)) % buyers.length);
      setMinutes(1 + Math.floor(Math.random() * 9));
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), SHOW_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-[96px] left-3 right-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto sm:w-[22rem]" data-id="element-34" data-mp="1fur1u40dbdrg">
      <AnimatePresence data-id="element-35" data-mp="1aysjax1q0pyy">
        {open && !dismissed && <motion.div key={`${buyer.name}-${minutes}`} role="status" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl bg-white p-2.5 pr-3 shadow-[0_18px_40px_-12px_rgba(6,18,48,0.45)] ring-1 ring-ink/10" data-id="element-36" data-mp="n86ah3jw71nw">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-paper object-cover" data-id="element-37" data-mp="23kboawvqct5h" />
            <div className="min-w-0 flex-1" data-id="element-38" data-mp="2anrz1fvepsmp">
              <p className="text-sm leading-snug text-ink" data-id="element-39" data-mp="2fnnyr2x2mxwg">
                <strong data-id="element-40" data-mp="2fm365iubhp18">
                  {buyer.name}
                </strong>{' '}
                from <strong data-id="element-41" data-mp="2ko276m2l49v0">{buyer.country}</strong> <span aria-hidden="true" data-id="element-42" data-mp="2kkwllgt5zq41">{buyer.flag}</span> just purchased the{' '}
                <strong data-id="element-43" data-mp="2pl2f72izvmor">ABG Clinical Roadmap™</strong>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-medium text-ok" data-id="element-44" data-mp="1rz4vx2wsjdbr">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-45" data-mp="1wy7z0ht7n9h3" />
                {minutes} {minutes === 1 ? 'minute' : 'minutes'} ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="self-start rounded-full p-1 text-ink/40 transition-colors duration-150 hover:bg-paper hover:text-ink" data-id="element-46" data-mp="26nhqpwk56q4o">
              <XIcon className="h-4 w-4" data-id="element-47" data-mp="3rgyifs5uuuju" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}